import {localeType} from '../libs/i18nextUtils';

export const langLabel: Record<localeType, string> = {
  [localeType.en]: 'English',
  [localeType.ru]: 'Russian',
};

export const langOptions: Array<localeType> = [localeType.en, localeType.ru];
